import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

const ElegantReadingWithVideo = ({ lectura, videoUrl, isStory = false, videoSource }) => {
  // Dividir el contenido en párrafos usando "\n"
  const parrafos = lectura.texto.split("\\n");

  var newVideoUrl = videoUrl

  if((videoSource || '').toLowerCase().includes("videoyoutube".toLowerCase())){

    const extractVideoId = (url) => {
      const match = url.match(/(?:\/shorts\/|v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      return match ? match[1] : null;
    };
    const videoId = extractVideoId(videoUrl);
    newVideoUrl=`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1`

  }else if((videoSource || '').toLowerCase().includes("videopinterest".toLowerCase())){
    newVideoUrl = videoUrl
  }

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      {/* Título */}
      <h1 className="text-5xl font-bold text-gray-900 mb-6 text-center">
        {lectura.titulo}
      </h1>

      {/* Metadatos */}
      <div className="flex justify-center space-x-4 text-sm text-gray-600 mb-8">
        <span>{lectura.tipo_lectura}</span>
        <span>•</span>
        <span>{JSON.parse(lectura.test).courses_hashtag}</span>
        <span>•</span>
        <span>{JSON.parse(lectura.test).level_of_school}</span>
      </div>

      {/* Contenedor principal: Video y Texto */}
      <div className="relative lg:overflow-hidden">
        {/* Video flotante en pantallas grandes */}
        <div className="mb-6 lg:float-left lg:w-1/2 lg:mr-8">
          <div className={`relative ${isStory ? "aspect-[9/16]" : "aspect-video"} overflow-hidden rounded-lg shadow-xl`}>
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={newVideoUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded video"
            />
          </div>
        </div>

        {/* Texto con estilo de lectura (usa 'prose' si tienes Tailwind Typography) */}
        <div className="prose max-w-none text-gray-700">
          {parrafos.map((parrafo, index) => (
            <ReactMarkdown
              key={index}
              remarkPlugins={[remarkMath]}
              rehypePlugins={[rehypeKatex]}
            >
              {parrafo}
            </ReactMarkdown>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ElegantReadingWithVideo;
